(function () {
  var swiper = new Swiper('.related-products__renders.swiper', {
    slidesPerView: 4,
    spaceBetween: 25,
    loop: false,
    autoplay: false,
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      770: {
        slidesPerView: 2,
        spaceBetween: 50,
      },
      1023: {
        slidesPerView: 4,
        spaceBetween: 25,
      },
    },
  });
})();